import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import { WebsiteState } from '../store';
import { selectActiveInputs } from './inputsSlice';
import { Json } from '@gift/types/Json';
import { matchActiveVariant } from '@gift/common/helpers/matchActiveVariant';
import { bindOptionSelectorFactory } from '@gift/common/helpers/pluginBindings';
import { BasicVariantOptions } from '@gift/basic-scene-core/BasicVariantOptions';

const adapter = createEntityAdapter<Json.Variant<any>>();
const adapterSelectors = adapter.getSelectors<WebsiteState>(s => s.variants);

export const { actions, reducer } = createSlice({
    name: 'variants',
    initialState: adapter.getInitialState(),
    reducers: {
        setAll: adapter.setAll
    }
});

export const selectAllVariants = createSelector(
    (state: WebsiteState) => state.variants.entities,
    v => Object.values(v) as Json.Variant<any>[]);

export const selectActiveVariant = createSelector([
    selectAllVariants,
    selectActiveInputs
], matchActiveVariant);

export const selectActiveVariantId = createSelector(
    selectActiveVariant,
    v => v.id);

export const createOptionBindings = <TOptions>() => ({
    createOptionSelector: bindOptionSelectorFactory(adapterSelectors).to<TOptions>()
});

const { createOptionSelector } = createOptionBindings<BasicVariantOptions>();

export const selectVariantViewboxById = createOptionSelector(o => o.viewbox);

export const selectVariantViewbox = createSelector([
    state => state,
    selectActiveVariantId
], (state, variantId) => selectVariantViewboxById(state, variantId)!);
